module.exports = __webpack_public_path__ + "static/media/ripple.9962ae9b.gif";